import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-69ad19ff")
const _hoisted_1 = ["data-feather", "width", "height", "fill"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bal-icon inline-block", {
      'bal-icon-setting': _ctx.changeType === 'setting',
      'bal-icon-create': ['createPool', 'trade', 'wallet'].includes(_ctx.changeType),
      'bal-icon-select': _ctx.changeType === 'select'
    }])
  }, [
    _createElementVNode("i", {
      "data-feather": _ctx.name,
      width: _ctx.iconSize,
      height: _ctx.iconSize,
      fill: _ctx.fill
    }, null, 8, _hoisted_1)
  ], 2))
}